import { render, staticRenderFns } from "./ListTableResidence.vue?vue&type=template&id=4de6634d&"
import script from "./ListTableResidence.vue?vue&type=script&lang=js&"
export * from "./ListTableResidence.vue?vue&type=script&lang=js&"
import style0 from "./ListTableResidence.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports